import { memo } from "react";

type DiceProps = {
  dice: {
    color: string;
    background: string;
  };
  value: number;
  description?: string;
};

export const Dice: React.FC<DiceProps> = memo(
  ({ dice, value, description }) => {
    const { color, background } = dice;
    let path;
    if (value === 1) {
      path =
        "M74.5 36A38.5 38.5 0 0036 74.5v363A38.5 38.5 0 0074.5 476h363a38.5 38.5 0 0038.5-38.5v-363A38.5 38.5 0 00437.5 36h-363zM256 206a50 50 0 010 100 50 50 0 010-100z";
    } else if (value === 2) {
      path =
        "M74.5 36A38.5 38.5 0 0036 74.5v363A38.5 38.5 0 0074.5 476h363a38.5 38.5 0 0038.5-38.5v-363A38.5 38.5 0 00437.5 36h-363zm316.97 36.03A50 50 0 01440 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zm-268 268A50 50 0 01172 390a50 50 0 01-100 0 50 50 0 0151.47-49.97z";
    } else if (value === 3) {
      path =
        "M74.5 36A38.5 38.5 0 0036 74.5v363A38.5 38.5 0 0074.5 476h363a38.5 38.5 0 0038.5-38.5v-363A38.5 38.5 0 00437.5 36h-363zm316.97 36.03A50 50 0 01440 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zM256 206a50 50 0 010 100 50 50 0 010-100zM123.47 340.03A50 50 0 01172 390a50 50 0 01-100 0 50 50 0 0151.47-49.97z";
    } else if (value === 4) {
      path =
        "M74.5 36A38.5 38.5 0 0036 74.5v363A38.5 38.5 0 0074.5 476h363a38.5 38.5 0 0038.5-38.5v-363A38.5 38.5 0 00437.5 36h-363zm48.97 36.03A50 50 0 01172 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zm268 0A50 50 0 01440 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zm-268 268A50 50 0 01172 390a50 50 0 01-100 0 50 50 0 0151.47-49.97zm268 0A50 50 0 01440 390a50 50 0 01-100 0 50 50 0 0151.47-49.97z";
    } else if (value === 5) {
      path =
        "M74.5 36A38.5 38.5 0 0036 74.5v363A38.5 38.5 0 0074.5 476h363a38.5 38.5 0 0038.5-38.5v-363A38.5 38.5 0 00437.5 36h-363zm48.97 36.03A50 50 0 01172 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zm268 0A50 50 0 01440 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zM256 206a50 50 0 010 100 50 50 0 010-100zM123.47 340.03A50 50 0 01172 390a50 50 0 01-100 0 50 50 0 0151.47-49.97zm268 0A50 50 0 01440 390a50 50 0 01-100 0 50 50 0 0151.47-49.97z";
    } else if (value === 6) {
      path =
        "M74.5 36A38.5 38.5 0 0036 74.5v363A38.5 38.5 0 0074.5 476h363a38.5 38.5 0 0038.5-38.5v-363A38.5 38.5 0 00437.5 36h-363zm48.97 36.03A50 50 0 01172 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zm268 0A50 50 0 01440 122a50 50 0 01-100 0 50 50 0 0151.47-49.97zM122 206a50 50 0 010 100 50 50 0 010-100zm268 0a50 50 0 010 100 50 50 0 010-100zM123.47 340.03A50 50 0 01172 390a50 50 0 01-100 0 50 50 0 0151.47-49.97zm268 0A50 50 0 01440 390a50 50 0 01-100 0 50 50 0 0151.47-49.97z";
    } else {
      return null;
    }

    // Utiliser la description fournie ou créer une description par défaut
    const diceAlt = description || `Dice ${value}`;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        aria-label={diceAlt}
      >
        <rect height="512" width="512" rx="80" ry="80" fill={color} />
        <path d={path} fill={background} />
      </svg>
    );
  }
);
